import React from 'react';
import Services from './../services/services';
import Breadcrumb from './../basics/Breadcrumb';

import {
  BrowserRouter as Router, Route, Routes, Link
} from "react-router-dom";

import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

const ShopHeader = (props: any) => {

  return (
    <div className="custom-shop-header card bg-dark text-white border-0 mb-5">
      <img src={props.image} className="card-img custom-radius-big-bottom" alt="..." />
      <div className="card-img-overlay d-flex flex-column justify-content-center container pt-5 mt-5">
        <div className="fs-1">{props.title}</div>
        <p className="card-text fs-4">{props.subtitle}</p>
      </div>
    </div>
  );
}

export default ShopHeader;
